import React, {Component} from 'react';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

class App extends Component {


  constructor(props) {
    super(props);
    this.state = {totalAmount: null, partialAmount: null, percent: null};
  }

  totalAmountHandler = (event) => {
    this.setState({totalAmount: event.target.value});
  }

  partialHandler = (event) => {
    
    this.setState({partialAmount: event.target.value});

    this.partialCalc(event.target.value);
  }

  percentHandler = (event) => {
    this.setState({percent: event.target.value});

    this.percentCalc(event.target.value);
  }

  partialCalc(partialAmount){
    let totalAmount = parseFloat(this.state.totalAmount);
    var partialAmount = parseFloat(partialAmount);

    
    this.setState({percent: ((100 * partialAmount) / totalAmount)});
  }

  percentCalc(percent){
    let totalAmount = parseFloat(this.state.totalAmount);
    var percent = parseFloat(percent);

    this.setState({partialAmount: ((percent / 100) * totalAmount)});
  }

  render() {

    const classes = makeStyles((theme) => ({
      root: {
        '& .MuiTextField-root': {
          margin: theme.spacing(1),
          width: '25ch',
        },
        start: {
          flexGrow: 1,
        },
        image: {
          width: 30,
          height: 30,
        }
      },
    }));

    return (
      <form className={classes.root} noValidate autoComplete="off">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid container justify="center" spacing={5}>
              <Grid key={0} style={{alignItems: "center", margin: 100}} item>
                {/* <img src={logo} alt="Infinitbility" style={{alignItems: "center", height: "50%", width: "50%"}}/> */}
                <Typography variant="h5" align={'center'} gutterBottom>Infinitbility Percentage Calculator</Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid container justify="center" spacing={5}>
              <Grid key={0} item>
                    <TextField
                  id="Total-Amount"
                  label="Total Amount"
                  type="number"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={this.state.totalAmount}
                  variant="filled"
                  onChange={this.totalAmountHandler.bind(this)}
                  
                />
              </Grid>
              <Grid key={1} item>
                    <TextField
                  id="Partial-Amount"
                  label="Partial Amount"
                  type="number"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={this.state.partialAmount}
                  onChange={this.partialHandler.bind(this)}
                  variant="filled"
                  
                />
              </Grid>
              <Grid key={2} item>
                    <TextField
                  id="Percent"
                  label="Percent"
                  type="number"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={this.state.percent}
                  onChange={this.percentHandler.bind(this)}

                  variant="filled"
                  
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>
    )};
}

export default App;